module.exports = __webpack_public_path__ + "svg/new-lindorff-small.782ae67ad7620702619f27ff36d83441.svg";